import { NgClass } from '@angular/common';
import { Component, ElementRef, Input, OnChanges, OnDestroy, OnInit, forwardRef } from '@angular/core';
import { ControlValueAccessor, FormsModule, NG_VALUE_ACCESSOR } from '@angular/forms';
import { delayHelper } from '@commonHelpers/delay-helper';
import { isNullish } from '@commonHelpers/math-utils';
import { KeyValue } from '@commonInterfaces/iKeyValue';
import { SearchHighLightPipe } from '@commonPipes/searchHightlight';
import { BasicControlValueAccessor } from '@commonSuper/basic-control-value-accessor';
import { NgbDropdown, NgbDropdownAnchor, NgbDropdownMenu } from '@ng-bootstrap/ng-bootstrap';

@Component({
    selector: 'lib-dropdown-search-box',
    templateUrl: './dropdown-search-box.component.html',
    styleUrls: ['./dropdown-search-box.component.scss'],
    providers: [{ provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => DropdownSearchBoxComponent), multi: true }],
    imports: [NgbDropdown, NgbDropdownAnchor, NgClass, FormsModule, NgbDropdownMenu, SearchHighLightPipe]
})
export class DropdownSearchBoxComponent extends BasicControlValueAccessor implements ControlValueAccessor, OnInit, OnDestroy, OnChanges {


	constructor(protected override elRef: ElementRef) {
		super(elRef)
	}

	@Input() override list?: SearchKeyValue[];
	@Input() infoDescription?: string;

	public searchlist?: SearchKeyValue[];
	public searchterm?: string;

	ngOnInit(): void {
		this.inputmode = true;
		this.init();
	}

	public changeValue(event: KeyboardEvent) {

		if (!this.dropdown?.isOpen()) {
			this.dropdown?.open();
		}

		if (event.key === 'ArrowDown' || event.key === 'ArrowUp') {

		} else {
			const nextIdx = this.list?.findIndex(item => item.key?.toLowerCase()?.startsWith(this.title?.toLowerCase()))
			this.scrollIntoView(nextIdx)
		}
	}

	public enterPress(event: KeyboardEvent) {
		if (event.key === 'Enter' || event.code === 'Enter' || event.code === 'NumpadEnter') {
			event.preventDefault();
			const item = this.title === '' ? this.list?.find(listItemValue => listItemValue.value === this.model) : (
				this.list?.find(listItemValue => listItemValue.key?.toLowerCase() === this.title?.toLowerCase()) ??
				this.list?.find(listItemValue => listItemValue.additionalValue?.toLowerCase() === this.title?.toLowerCase()) ??
				this.list?.find(listItemValue => listItemValue.key?.toLowerCase()?.startsWith(this.title?.toLowerCase())) ??
				this.list?.find(listItemValue => listItemValue.additionalValue?.toLowerCase()?.startsWith(this.title?.toLowerCase())))
			if (!isNullish(item)) {
				this.title = item.key;
				this.model = item.value;

			} else {
				this.resetData();
			}
			return;
		}
	}

	public resetData() {
		const listData = this.list?.find(item => this.model === item.value);
		this.title = listData?.key ?? "";
	}

	protected focusOnOpen() {
		this.searchterm = '';
		this.searchlist = this.list;
		delayHelper(() => {

			const input = this.elRef.nativeElement.querySelector('.form-input');
			input?.focus();
			input?.select();
		})
	}

	protected override initCustomList() {
		this.searchlist = this.list;
	}

	protected override navigateList() {
		return this.searchlist ?? [];
	}

	public search(term: string) {
		this.searchterm = term;
		const listItem = this.list?.find(item => item.key?.toLowerCase() === this.title?.toLowerCase() || item.additionalValue?.toLowerCase() === term.toLowerCase());
		if (!isNullish(listItem)) {
			this.title = listItem.key;
			this.model = listItem.value;
		}
		this.searchlist = isNullish(term) || term === '' ?
			this.list :
			this.list?.filter(item => item.key.toLowerCase().includes(term.toLowerCase()) || item.additionalValue?.toLowerCase().includes(term.toLowerCase()));
	}

}

export interface SearchKeyValue extends KeyValue {
	additionalValue?: string;
}
